module.exports = __webpack_public_path__ + "img/violet_101.e89002d8.png";